const _Hub_Name = "conversationhub";

const _Invoke_Methods_Names = {
  startConvo: "StartConversation",
  sendMessage: "SendMessage",

  // email conversation
  startEmailConversation: "StartEmailConversation",
  sendEmail: "SendEmail",
  resendEmail: "ResendEmail",
  joinConversationRoom: "JoinConversationRoom",
  leftConversationRoom: "LeftConversationRoom",

  // mark sms as seen
  markSmsAsSeenRequest: "MarkSmsAsSeen",
  // mark email as seen
  markEmailAsSeenRequest: "MarkEmailAsSeen",
};

const _OnReceive_Methods_Names = {
  onMessageReceived: "OnMessageReceived",
  onStartConversationResponse: "StartConversationResponse",
  onSendMessageResponse: "SendMessageResponse",
  onSmsStatusChanged: "OnSmsStatusChanged",

  // email conversation response
  onStartEmailConversation: "StartEmailConversationResponse",
  onSendEmail: "SendEmailResposne",
  OnEmailReceived: "OnEmailReceived",
  onResendEmailResposne: "ResendEmailResposne",

  // mark sms as seen listener
  onMarkSmsAsSeenResponse: "MarkSmsAsSeenResponse",
  // mark email as seen listener
  onMarkEmailAsSeenResponse: "MarkEmailAsSeenResponse",
};

const Convo_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Convo_signalr;
